import * as React from 'react';
import { TableBody, TableCell, TableRow } from '@material-ui/core';
import { MemberCloset } from 'types/member/memberCloset';
import SpinnerRow from 'components/common/table/datatable/SpinnerRow';
import NoResultRow from 'components/common/table/datatable/NoResultRow';
import DataTableRow from 'components/common/table/datatable/DataTableRow';
import { memberClosetTableColumn } from './memberClosetTableColumn';

interface Props {
  memberCloset: MemberCloset;
  isLoading: boolean;
}

const MemberClosetTableBody = ({ memberCloset, isLoading }: Props) => {
  if (isLoading) {
    return (
      <TableBody>
        <SpinnerRow colspan={100} spinnerSize={20} />
      </TableBody>
    );
  }

  if (memberCloset.accessibleGroups.length === 0) {
    return (
      <TableBody>
        <NoResultRow colspan={100} />
      </TableBody>
    );
  }

  return (
    <TableBody>
      {memberCloset.accessibleGroups.map((group, index) => (
        <DataTableRow
          key={group.groupName}
          row={group}
          rowIndex={index}
          columns={memberClosetTableColumn}
        />
      ))}
    </TableBody>
  );
};

export default MemberClosetTableBody;
